/** 请求错误按连续故障去重；关闭提示不会解除去重，避免轮询再次打断用户。 */
export function createRequestErrorNotice(show) {
  let sequence = 0 // 为每次请求标记发出顺序，区分故障前已在途的响应。
  const failed = new Map() // 只保存接口范围、错误类型和序号，不保存请求参数、密码或验证码。
  const shown = new Set() // 同一故障即使多个接口同时失败，也只显示一次提示。
  const scope = config => [config.method || 'get', config.baseURL || '', (config.url || '').split('?')[0]].join(':') // 同一接口的不同查询参数不制造多个系统错误提示。
  const release = key => { if (![...failed.values()].some(item => item.key === key)) shown.delete(key) } // 所有已失败接口都恢复后，才允许提示下一次同类故障。

  return {
    begin(config) { config.pcErrorNoticeSequence = ++sequence }, // 使用拦截器中的自定义配置字段，不发送额外 HTTP 请求头。
    failure(config = {}, message, key) {
      if (config.silentError === true) return // 表单或后台请求自己处理错误时，不显示全局提示。
      const endpoint = scope(config); const previous = failed.get(endpoint) // 一个接口只保存最近尚未恢复的错误状态。
      failed.set(endpoint, { key, after: sequence }) // 在提示前记录状态，快速并发返回的请求也无法重复显示。
      if (previous && previous.key !== key) release(previous.key) // 错误类型变更后不永久保留无接口引用的旧提示记录。
      if (shown.has(key)) return // 关闭提示、计时器重试和其他接口成功都不会解除此门禁。
      shown.add(key); show(message) // 展示非阻塞提示，原请求仍由拦截器正常 reject。
    },
    success(config = {}) {
      const endpoint = scope(config); const previous = failed.get(endpoint) // 无关接口成功不能当成整轮故障已经恢复。
      if (!previous || !(config.pcErrorNoticeSequence > previous.after)) return // 故障发生前已发出的成功响应，不能清除新故障。
      failed.delete(endpoint); release(previous.key) // 只有该接口在故障发生后重新请求成功，才解除其故障状态。
    },
    reset() { failed.clear(); shown.clear() } // 切换到新的普通登录会话时，避免沿用上一位用户的提示状态。
  }
}
